import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { useSignInContext } from '../../../context/SignInContext';
import { parse, stringify } from '../../../util/urlHelpers';

const isMobileViewport = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.innerWidth < 768;
};

const LoginQueryParamHandler = () => {
  const history = useHistory();
  const location = useLocation();
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated || false);
  const { openSignIn } = useSignInContext();

  useEffect(() => {
    const queryParams = parse(location.search);

    if (queryParams.login !== 'true') {
      return;
    }

    if (!isAuthenticated) {
      openSignIn({
        defaultToLogin: true,
        fullScreenOnMobile: isMobileViewport(),
      });
    }

    const nextQueryParams = { ...queryParams };
    delete nextQueryParams.login;
    const nextSearch = stringify(nextQueryParams);

    history.replace({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: location.hash,
      state: location.state,
    });
  }, [history, isAuthenticated, location, openSignIn]);

  return null;
};

export default LoginQueryParamHandler;
